module.exports = __webpack_public_path__ + "img/star.e55ca5ce.svg";